import common from '../common'
/**
 *  * 网页分享
 * @param url  地址
 * @param title 标题
 * @param description  描述
 * @param imgUrl  分享icon
 * @param judge  类型选择 好友-0 朋友圈-1
 */
const wxUrlShare = (url, title, description, imgUrl = '', judge = 0, callback) => {
    try {
        // 安卓
        if( !common?.isAndroid_ios() ) {
            if (!!window?.androidNative?.WxUrlShare) {
                window?.androidNative?.WxUrlShare(url, title, description, imgUrl, judge)
                callback && callback()
            }
        }else {
            if( window?.webkit?.messageHandlers?.WxUrlShare) {
                window?.webkit.messageHandlers.WxUrlShare.postMessage({
                    url:url || '', 
                    title:title || '', 
                    description:description || '', 
                    imgUrl:imgUrl || '', 
                    judge:judge || 0
                })
                callback && callback()
            }
        }
    } catch (error) {
        console.log(error)
    }
}
export default wxUrlShare